import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import objectAssign from 'object-assign';
import { Checkbox, Icon, Message, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import PopupHeader from '../../popupHeader';
import Info from '../../info.js';
import Modal from 'components/shared/modal/content';
import { showMRManageRolesModal } from 'actions/modal.js';
import { updateRolesForMeetingRoomUser } from 'actions/user';
import { setManageRoleForm } from 'actions/meetingRoom';
import { canIUseVCM, userRedirectPageAfterLogin, logout } from '../../../../businessLogic/authorizator';
import { stringReplace } from 'businessLogic/string';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ManageRolesForUsersContent(props) {
  const dispatch = useDispatch();
  const [updatingRolesForUserList, setUpdatingRolesForUserList] = useState(false);

  useLayoutEffect(() => {
    let rolesAssignedToUser = getRolesAssignedToUser(props.availableRoles);
    dispatch(setManageRoleForm(rolesAssignedToUser));
  }, []);

  const getSelectedUser = (usersIcanManage, manageRolesSelectedUserId) => {
    return usersIcanManage.find((userIManage) => userIManage.id === manageRolesSelectedUserId);
  };

  const getRolesAndEntity = (meetingRoom) => {
    let user = getSelectedUser(props.usersIcanManage, props.manageRolesSelectedUserId);
    if (user != undefined) {
      let roleArray = [];
      user.role.split(',').map((role) => {
        roleArray.push(role.split('_')[0].trim());
      });
      return roleArray;
    }
    return [];
  };

  const getRolesAssignedToUser = (availableRoles) => {
    let rolesAndEntity = getRolesAndEntity(props.selectedMeetingRoom);
    let rolesSelected = [];
    availableRoles.map((individualRole, index) => {
      let newObject = {
        id: individualRole.id,
        name: individualRole.name,
        selected: rolesAndEntity.includes(individualRole.name) || false,
      };
      rolesSelected.push(newObject);
    });

    return rolesSelected;
  };

  const updateRolesForUser = () => {
    // Avoid multiple button clicks
    if (updatingRolesForUserList) {
      return;
    }

    let rolesAssignedToUser = props.rolesForSelectedUser;
    let newSelectedRoles = rolesAssignedToUser.filter((availableRolesForThisUser) => {
      return availableRolesForThisUser.selected === true;
    });
    let newRolesIdArray = [];
    newSelectedRoles.map((selectedRole) => {
      newRolesIdArray.push(selectedRole.id);
    });

    setUpdatingRolesForUserList(true);

    let cb = (showModal) => {
      setUpdatingRolesForUserList(false);
      dispatch(showMRManageRolesModal(showModal));
    };
    let user = getSelectedUser(props.usersIcanManage, props.manageRolesSelectedUserId);
    dispatch(updateRolesForMeetingRoomUser(props.selectedMeetingRoom.id, user, newRolesIdArray, cb));
  };

  const resetManageRolesForm = () => {
    let rolesAssignedToUser = getRolesAssignedToUser(props.availableRoles);
    dispatch(setManageRoleForm(rolesAssignedToUser));
  };

  const cancelRolesForUser = () => {
    dispatch(showMRManageRolesModal(false));
    resetManageRolesForm();
  };

  const handleCheckboxChecked = (event, data) => {
    let lastRolesState = props.rolesForSelectedUser;
    let index = lastRolesState.findIndex((role) => {
      return role.name === data.name;
    });

    let oldRoleSelected = lastRolesState[index];
    lastRolesState[index] = objectAssign({}, oldRoleSelected, {
      selected: data.checked,
    });
    dispatch(setManageRoleForm(lastRolesState));
  };

  let user = getSelectedUser(props.usersIcanManage, props.manageRolesSelectedUserId);
  let rolesAndEntity = getRolesAndEntity(props.selectedMeetingRoom);
  let rolesAssignedToUser = getRolesAssignedToUser(props.availableRoles);
  let title = APP.LANGUAGE.MeetingRoomManageRolesForUsersListModal.Title;
  let subtitle = user.firstName + ' ' + user.lastName + ' in ' + props.selectedMeetingRoom.name;
  let availableRolesMarkUp = '';
  let introPartText = '';

  if (rolesAndEntity.length > 0) {
    introPartText = APP.LANGUAGE.MeetingRoomManageRolesForUsersListModal.IntroPartText.replace(
      '##userFirstName##',
      user.firstName
    )
      .replace('##userLastName##', user.lastName)
      .replace('##userEmail##', user.email)
      .replace('##entityName##', props.selectedMeetingRoom.name)
      .replace(
        '##entityType##',
        stringReplace(
          'Meeting Room',
          APP.LANGUAGE.MeetingRoomManageUsers.Group,
          APP.LANGUAGE.MeetingRoomManageUsers.MeetingRoom
        )
      );
  }

  const renderAvailableRoles = (isOnDesktop) => {
    if (props.rolesForSelectedUser && props.rolesForSelectedUser.length) {
      return props.availableRoles.map((role, index) => {
        return (
          <Checkbox
            name={role.name}
            key={index}
            tabIndex={index}
            className={'div-like ' + (isOnDesktop ? 'mrbs' : 'mrbm')}
            onClick={(e, data) => handleCheckboxChecked(e, data)}
            label={role.name}
            defaultChecked={
              props.rolesForSelectedUser &&
              props.rolesForSelectedUser.some((roleObject) => {
                return roleObject.name === role.name && roleObject.selected === true;
              })
            }
          />
        );
      });
    }
  };

  const emptyWarning = (onMobile) => {
    let warningClass = 'borderless bg-transparent pdlnull pdrnull';
    if (onMobile) {
      warningClass = warningClass + ' color-bad-things-text-on-mobile';
    } else {
      warningClass = warningClass + ' color-bad-things-text';
    }
    return (
      <Message icon className={warningClass}>
        <Icon name="exclamation circle" className="mrrm" />
        <Message.Content>
          <div>
            {htmlToReactParser.parse(
              xss(
                APP.LANGUAGE.MeetingRoomManageRolesForUsersListModal.WarningWhenEmpty.replace(
                  '##entityType##',
                  APP.LANGUAGE.MeetingRoomManageUsers.MeetingRoom
                )
              )
            )}
          </div>
        </Message.Content>
      </Message>
    );
  };

  // Right panel
  let buttonClasses = 'ui labeled icon button left-text color-white max-width  mrlnull mrbnull';
  let rightPanel = (
    <div>
      <div className="ui actions mrtxxs mrbl max-width">
        <button
          tabIndex="4"
          type="button"
          onClick={updateRolesForUser}
          className={
            updatingRolesForUserList
              ? buttonClasses + ' color-button color-button-hover loading'
              : buttonClasses + ' color-button color-button-hover'
          }
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button
          tabIndex="5"
          type="button"
          onClick={cancelRolesForUser}
          className={buttonClasses + ' color-bad-things color-bad-things-hover mrtm'}
        >
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <Info paragraphs={[APP.LANGUAGE.MeetingRoomManageRolesForUsersListModal.InfoPart]} />
    </div>
  );

  let canSeeEmptyWarning =
    !!props.rolesForSelectedUser &&
    !props.rolesForSelectedUser.some((eachRole) => {
      return eachRole.selected === true;
    });

  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.MeetingRoomManageUsers.HelpManageRoles}
        title={title}
        subtitle={subtitle}
      />
      <div className="content">
        <div className="main-ui-container manage-roles-for-users-modal">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            <div>
              <div className="ui form mrbxxl">
                <div className="placeholder-label color-placeholder div-like mrbs">
                  {htmlToReactParser.parse(xss(introPartText))}
                </div>
                {/*availableRolesMarkUp*/}
                <Container fluid as={Media} lessThan="computer">
                  {renderAvailableRoles(false)}
                  {canSeeEmptyWarning ? emptyWarning(true) : ''}
                </Container>
                <Container fluid as={Media} greaterThanOrEqual="computer">
                  {renderAvailableRoles(true)}
                  <div className={canSeeEmptyWarning ? 'mrtm mrbm' : 'mrtm mrbm invisible'}>{emptyWarning(false)}</div>
                </Container>
              </div>
            </div>
          </div>
          <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
        </div>
      </div>
    </Modal>
  );
}
